const Constants = {
    whatsApp: 'https://api.whatsapp.com/send?phone=5511987870314',
    instagram: 'https://www.instagram.com/rl_cabelos_aclimacao/',
  }
  
  export default Constants